import React, { useRef, useState, useLayoutEffect, useCallback } from 'react';
import { getTemplate } from './templates';

const DOC_WIDTH = 720;

/**
 * Aperçu d'une facture dans le modèle choisi, mis à l'échelle pour tenir
 * dans la largeur disponible (le document garde son ratio A4).
 */
export default function InvoicePreview({ templateId, invoice, branding }) {
  const { Component } = getTemplate(templateId);
  const wrapRef = useRef(null);
  const docRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [height, setHeight] = useState(undefined);

  const measure = useCallback(() => {
    const wrap = wrapRef.current;
    const doc = docRef.current;
    if (!wrap || !doc) return;
    const s = Math.min(wrap.clientWidth / DOC_WIDTH, 1);
    setScale(s);
    setHeight(doc.offsetHeight * s);
  }, []);

  // Re-mesure au montage + quand le contenu change
  useLayoutEffect(() => {
    measure();
  }, [measure, templateId, invoice, branding]);

  // Re-mesure quand le conteneur change de taille
  useLayoutEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(measure);
    ro.observe(wrap);
    return () => ro.disconnect();
  }, [measure]);

  return (
    <div ref={wrapRef} style={{ width: '100%', overflow: 'hidden' }}>
      <div style={{ height }}>
        <div
          ref={docRef}
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            width: DOC_WIDTH,
            boxShadow: '0 12px 45px rgba(0,0,0,0.4)',
            borderRadius: 4,
            overflow: 'hidden',
          }}
        >
          <Component invoice={invoice} branding={branding} />
        </div>
      </div>
    </div>
  );
}
